export default {"src":"/_next/static/media/user-laptop.3760df11.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};